export default __webpack_public_path__ + "static/media/clip-icon.50bc5f76.png";